var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhatsappIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_594",
    "data-name": "Grupo 594",
    transform: "translate(-240 -135)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ret\\xE2ngulo_175",
    "data-name": "Ret\\xE2ngulo 175",
    transform: "translate(240 135)",
    fill: "#dcdcdc",
    stroke: "#dcdcdc",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 7.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-logo-whatsapp",
    "data-name": "Icon ionic-logo-whatsapp",
    d: "M10.828,2.25a8.24,8.24,0,0,0-8.272,8.208A8.123,8.123,0,0,0,3.743,14.7L2.25,19.1l4.58-1.455A8.286,8.286,0,0,0,19.1,10.458,8.24,8.24,0,0,0,10.828,2.25Zm4.113,11.325a2.137,2.137,0,0,1-1.463.943c-.388.021-.4.3-2.514-.618a8.631,8.631,0,0,1-3.487-3.3A4.057,4.057,0,0,1,6.7,8.4,2.344,2.344,0,0,1,7.5,6.684a.81.81,0,0,1,.573-.241c.167,0,.274,0,.4,0s.308-.026.468.4.543,1.473.592,1.579a.383.383,0,0,1,0,.368,1.437,1.437,0,0,1-.224.342c-.11.118-.232.265-.331.355s-.225.21-.109.424a6.33,6.33,0,0,0,1.12,1.495,5.771,5.771,0,0,0,1.659,1.1c.207.113.331.1.46-.035s.551-.592.7-.8.288-.164.479-.088,1.209.623,1.417.735.346.17.4.26A1.737,1.737,0,0,1,14.941,13.575Z",
    transform: "translate(249.75 144.75)",
    fill: "#fd1c50"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappIcon);
export default __webpack_public_path__ + "static/media/whatsappIcon.42075bc602ca3961ec81eae5a0a5a2a0.svg";
export { ForwardRef as ReactComponent };